import * as z from "zod/v4";
import { null as zNull } from "zod/v4";

export const reorderParcels = {
  name: "reorderParcels" as const,
  input: z.object({
    parcels: z.array(z.object({ name: z.string(), position: z.number() })),
  }),
  output: zNull(),
};
